module.exports = __webpack_public_path__ + "img/video_white.bbba5722.svg";